import React from "react";
import PropTypes from "prop-types";
import { Descriptions } from "../constants/descriptions";
import {
  FormGroup,
  Select,
  InputHelperText,
  Label,
} from "../../../components/atoms/Form";
import { STATUS_CODES } from "../helpers/helpers";

const RecordStatus = (props) => {
  const {
    onChange,
    errors,
    touched,
    handleBlur,
    recordStatus,
    statusCode,
    clinvarAccession,
  } = props;

  const onChangeRecordStatus = (e) => {
    onChange(e.target.value, "recordStatus");
  };

  return (
    <FormGroup className="tw-flex tw-w-6/12">
      <Label text="Record Status" isRequired={true} />
      <Select
        type="select"
        name="recordStatus"
        onChange={(event) => onChangeRecordStatus(event)}
        onBlur={(e) => handleBlur(e)}
        value={recordStatus}
      >
        {(statusCode === STATUS_CODES.PUBLISHED_ON_CLINVAR ||
          statusCode === STATUS_CODES.PROCESSED_NOT_PUBLISHED) && (
          <option value="update">update</option>
        )}
        {statusCode === STATUS_CODES.ERROR && clinvarAccession && (
          <option value="update">update</option>
        )}
        {statusCode === STATUS_CODES.ERROR && !clinvarAccession && (
          <option value="novel">novel</option>
        )}
        {(statusCode === STATUS_CODES.PROCESSING ||
          statusCode === STATUS_CODES.SUBMITTED) && (
          <option value={recordStatus}>{recordStatus}</option>
        )}
        {!statusCode && <option value="novel">novel</option>}
      </Select>
      {!touched.recordStatus || !errors.recordStatus ? (
        <InputHelperText>{Descriptions.recordStatus}</InputHelperText>
      ) : (
        <InputHelperText type="error">{errors.recordStatus}</InputHelperText>
      )}
    </FormGroup>
  );
};

RecordStatus.propTypes = {
  onChange: PropTypes.func.isRequired,
  recordStatus: PropTypes.string,
  statusCode: PropTypes.number,
  clinvarAccession: PropTypes.string.isRequired,
  handleBlur: PropTypes.func.isRequired,
  errors: PropTypes.objectOf(
    PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.shape({}),
      PropTypes.arrayOf(PropTypes.shape({})),
    ])
  ).isRequired,
  touched: PropTypes.objectOf(
    PropTypes.oneOfType([
      PropTypes.bool,
      PropTypes.shape({}),
      PropTypes.arrayOf(PropTypes.shape({})),
    ])
  ).isRequired,
};

RecordStatus.defaultProps = {
  recordStatus: null,
  statusCode: 0,
};

export default RecordStatus;
